"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateServerClientUsingCookies = exports.generateServerClientUsingReqRes = void 0;
var generateServerClient_1 = require("./generateServerClient");
Object.defineProperty(exports, "generateServerClientUsingReqRes", { enumerable: true, get: function () { return generateServerClient_1.generateServerClientUsingReqRes; } });
Object.defineProperty(exports, "generateServerClientUsingCookies", { enumerable: true, get: function () { return generateServerClient_1.generateServerClientUsingCookies; } });
